import { TextField } from 'mui-rff';
import React from 'react';

import { DomainNameVerificationStatus, useDomainNameVerificationsQuery } from '@dashboard/generated/wp/platform';
import { MenuItem } from '@mui/material';

type Props = {
  name: string;
};
export default function SelectDomainField({ name }: Props) {
  const { data } = useDomainNameVerificationsQuery();
  const nodes = data?.DomainNameVerifications.nodes;

  if (nodes === undefined) {
    return <TextField variant="standard" label="" disabled name={name} />;
  }

  return (
    <TextField variant="standard" label="" select name={name}>
      {nodes.map(renderMenuItem)}
    </TextField>
  );
}

type TMenuItemProps = {
  id: string;
  domainName: string;
  status: DomainNameVerificationStatus;
};
function renderMenuItem({ id, domainName, status }: TMenuItemProps) {
  let statusLabel = null;
  switch (status) {
    case DomainNameVerificationStatus.Failed:
      statusLabel = '(failed)';
      break;
    case DomainNameVerificationStatus.Pending:
      statusLabel = '(pending)';
      break;
    case DomainNameVerificationStatus.Succeeded:
    default:
      break;
  }
  return (
    <MenuItem key={id} value={id}>
      {domainName} {statusLabel}
    </MenuItem>
  );
}
